var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"form-item"},[_c('div',{staticClass:"label",class:{ required: _vm.required }},[_vm._v(" "+_vm._s(_vm.label)+" "),_c('span',[_vm._v(_vm._s(_vm.desc))])]),_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }